export default {
    app: 'Folio',
    selectedConids: [],
    folioModels: [],
    selectedModel: {},
    performanceChartData: {},
    savedModelStatus: {},
    rebalancedOrderDetails: {},
    transmitOrdersStatus: {},
    modelOrdersStatus: {},
    modelTargetList: []
}
